module.exports = __webpack_public_path__ + "static/media/support.ad9d8c2f.svg";